export function trackingOnView (tracker_target, event, id, name, link, position) {
    if (tracker_target == "artikel") {
        let data = {
            event: event,
            ecommerce: {
                promotion_id: id, // unique ID banner
                promotion_name: name, // Header - {{banner name}}
                creative_name: link, // destination url
                creative_slot: position
            }
        }
         console.log(data)
        return dataLayer.push(data);
    } else {
        return null;
    }
}

export function trackingOnClick (tracker_target, event, id, name, link, position) {
    if (tracker_target == "artikel") {
        let data = {
            event: event,
            ecommerce: {
                promotion_id: id, // unique ID banner
                promotion_name: name, // Header - {{banner name}}
                creative_name: link, // destination url
                creative_slot: position
            }
        }
        // console.log(data)
        return dataLayer.push(data);
    }
    else {
        return null;
    }
}
